import { CustomButton } from 'holistic-resources';
import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { getFullname } from 'shared/helpers/common';
import SignOutButton from './SignOutButton';

export default function SmallScreenNavBar({ toggleSmallScreenNavBar }) {
  const { userData } = useSelector((state) => state.currentUser);
  const { componentConfig, latestBookings, latestQuotes } = useSelector(
    (state) => state.ui,
  );
  const { first: firstName, last: lastName } = userData?.fullName || {};
  const { whiteLabelSettings: { secondaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <div className="z-[3] bg-white fixed h-full inset-y-0 right-0 left-2/4 rounded-bl-xl rounded-tl-xl border md:left-3/4 sm:left">
      <div>
        <div className="flex w-full justify-between items-center border-b h-14">
          <div className="p-4 font-bold">Menu</div>
          <CustomButton
            style={{ color: secondaryColour }}
            className="px-3 py-2"
            onClick={() => toggleSmallScreenNavBar(false)}
          >
            <MdClose />
          </CustomButton>
        </div>
        <nav>
          <ul className="my-4">
            {latestBookings?.length > 0 && componentConfig.bookingsEnabled && (
              <li className="font-bold px-4 py-2 hover:bg-default-hover">
                <Link to={ROUTES_SELF_SERVICE.BOOKINGS}>
                  <div>Bookings</div>
                </Link>
              </li>
            )}
            {latestQuotes?.length > 0 && componentConfig.quotesEnabled && (
              <li className="font-bold px-4 py-2 hover:bg-default-hover">
                <Link to={ROUTES_SELF_SERVICE.QUOTES}>
                  <div>Quotes</div>
                </Link>
              </li>
            )}
            {componentConfig.documentsEnabled && (
              <li className="font-bold px-4 py-2 hover:bg-default-hover">
                <Link to={ROUTES_SELF_SERVICE.DOCUMENTS}>
                  <div>My Travel Documents</div>
                </Link>
              </li>
            )}
            {componentConfig.profileEnabled && (
              <li className="font-bold px-4 py-2 hover:bg-default-hover">
                <Link to={ROUTES_SELF_SERVICE.PROFILE}>
                  <div>Personal Details</div>
                </Link>
              </li>
            )}
          </ul>
        </nav>
        <div>
          <div className="mt-6 font-bold mx-4">
            {getFullname({ firstName, lastName })}
          </div>
          <ul className="pt-3">
            <li className="px-4 pb-3 pt-2 hover:bg-default-hover">
              <SignOutButton className="w-full" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
